import {
	Helpers,
	IRuleType,
	RuleEngineEntities,
	RuleEngineLegacyEntities,
	RuleType
} from '@bimser/components/dist/BCRuleManager';
import { IDictionary, ReadonlyRecord } from '@bimser/core';
import { Map, Record } from 'immutable';

export interface IFormRuleTriggerPayloadBase {
	windowId: string;
	validate?: boolean;
	projectName: string;
	packageVersion: number;
}

export interface IFormRuleTriggerPayload extends IFormRuleTriggerPayloadBase {
	rules: IDictionary<IRuleType>;
}

export interface IReadonlyBaseFormRuleTriggerPayload extends IFormRuleTriggerPayloadBase {
	rules: Map<string, RuleType>;
}

export type FormRuleTriggerPayload = ReadonlyRecord<IReadonlyBaseFormRuleTriggerPayload>;

export const FormRuleTriggerPayloadFactory = Record<IReadonlyBaseFormRuleTriggerPayload>({
	windowId: null,
	validate: true,
	rules: Map(),
	projectName: null,
	packageVersion: null
});

export const FormRuleTriggerPayloadFactoryFromJS = function (data: IFormRuleTriggerPayload) {
	const rules: IDictionary<RuleType> = Object.keys(data.rules).reduce(function (
		previous: IDictionary<RuleType>,
		current
	) {
		const rule = data.rules[current];
		if (Helpers.isLegacyRule(rule)) {
			previous[current] = RuleEngineLegacyEntities.RuleFactoryFromJS(rule);
		} else {
			previous[current] = RuleEngineEntities.RuleFactoryFromJS(rule);
		}
		return previous;
	}, {});

	return FormRuleTriggerPayloadFactory({
		windowId: data.windowId,
		rules: Map(rules),
		validate: data.validate,
		projectName: data.projectName,
		packageVersion: data.packageVersion
	});
};
